/**
 * Pre-order button label only.
 *
 * Intentionally does not touch Recharge/custom purchase widgets, radios,
 * selling plans, or other page scripts. Only rewrites the add-to-cart label
 * and re-applies it when theme JS resets the button after a variant change.
 */
(function () {
  var PRODUCT_IDS = ['15520893665655'];
  var LABEL = 'Pre-order';
  var BUTTON_TEXT_SELECTOR = '.js-product-form-submit-btn-text';
  var MAX_FIND_ATTEMPTS = 20;
  var applying = false;
  var observer = null;

  function getProductId() {
    if (document.body && document.body.dataset.productId) {
      return String(document.body.dataset.productId);
    }
    var input = document.querySelector('input[name="product-id"]');
    return input ? String(input.value) : null;
  }

  if (PRODUCT_IDS.indexOf(getProductId()) === -1) {
    return;
  }

  function applyLabel() {
    if (applying) return;
    applying = true;
    var buttons = document.querySelectorAll(BUTTON_TEXT_SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].textContent.trim() !== LABEL) {
        buttons[i].textContent = LABEL;
      }
    }
    applying = false;
  }

  function observeButtons() {
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () {
      if (!applying) applyLabel();
    });

    var buttons = document.querySelectorAll(BUTTON_TEXT_SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      var target = buttons[i].closest('.js-product-form-submit-btn') || buttons[i];
      observer.observe(target, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  function start(attempt) {
    applyLabel();
    var found = document.querySelector(BUTTON_TEXT_SELECTOR);
    if (found) {
      observeButtons();
      return;
    }
    if (attempt < MAX_FIND_ATTEMPTS) {
      setTimeout(function () {
        start(attempt + 1);
      }, 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      start(0);
    });
  } else {
    start(0);
  }
})();
